import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import './i18n'; // Import i18n configuration
import Home from './pages/Home';
import Shop from './pages/Shop';
import About from './pages/About';
import Contact from './pages/Contact';
import Shipping from './pages/Shipping';
import Cart from './pages/Cart';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ConfirmSignup from './pages/ConfirmSignup';
import MyOrders from './pages/MyOrders';
import MyProfile from './pages/MyProfile';
import ProductDetails from './pages/ProductDetails';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentOptionsDemo from './components/PaymentOptionsDemo';
import CheckoutDemo from './pages/CheckoutDemo';
import OrderConfirmation from './pages/OrderConfirmation';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/shipping" element={<Shipping />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/confirm-signup" element={<ConfirmSignup />} />
            <Route path="/my-orders" element={<MyOrders />} />
            <Route path="/my-profile" element={<MyProfile />} />
            <Route path="/product/:id" element={<ProductDetails />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-options-demo" element={<PaymentOptionsDemo />} />
            <Route path="/checkout-demo" element={<CheckoutDemo />} />
            <Route path="/order-confirmation" element={<OrderConfirmation />} />
          </Routes>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
